// WaterCalibarationLog.js
// This is the class for the water calibration log rows, which will be used to create the water calibration log table.
import { v4 as uuidv4 } from "uuid";

export class WaterCalibrationLog {
  constructor(data = {}) {
    // Using the ID from the backend if available, or generating a unique ID if not
    this.id = data.id || uuidv4();
    this.samplingEventId = data.sampling_event_id || "";
    this.calibrationDate = data.calibration_date || null;
    this.calibrationTime = data.calibration_time || null;
    this.instrument = data.instrument || "";
    this.fieldParameter = data.field_parameter || "";
    this.standardUsed = data.standard_used || "";
    this.verification = data.verification || null;
    this.units = data.units || "";
    this.passFail = data.pass_fail || "";
    this.employeeId = data.employee_id || null;
    this.employeeName = data.employee_name || "";
    this.createdAt = data.created_at || null;
    this.updatedAt = data.updated_at || null;
  }

  setCalibrationDate(calibrationDate) {
    if (!calibrationDate) {
      this.calibrationDate = null;
      return;
    }
    this.calibrationDate = calibrationDate;
  }

  setCalibrationTime(calibrationTime) {
    if (!calibrationTime) {
      this.calibrationTime = null;
      return;
    }
    this.calibrationTime = calibrationTime;
  }

  setInstrument(instrument) {
    if (!instrument) {
      this.instrument = "";
      return;
    }
    this.instrument = instrument;
  }

  setFieldParameter(fieldParameter) {
    if (!fieldParameter) {
      this.fieldParameter = "";
      return;
    }
    this.fieldParameter = fieldParameter;
  }

  setVerification(verification) {
    if (!verification) {
      this.verification = "";
      return;
    }
    this.verification = verification;
  }

  setStandardUsed(standardUsed) {
    if (!standardUsed) {
      this.standardUsed = "";
      return;
    }
    this.standardUsed = standardUsed;
  }

  setUnits(units) {
    if (!units) {
      this.units = "";
      return;
    }
    this.units = units;
  }

  setPassFail(passFail) {
    if (!passFail) {
      this.passFail = "";
      return;
    }
    this.passFail = passFail;
  }

  setEmployeeId(employeeId) {
    if (!employeeId) {
      this.employeeId = "";
      return;
    }
    this.employeeId = employeeId;
  }

  setEmployeeName(employeeName) {
    if (!employeeName) {
      this.employeeName = "";
      return;
    }
    this.employeeName = employeeName;
  }

  updateFromPatch(patch) {
    this.calibrationDate = patch.calibration_date;
    this.calibrationTime = patch.calibration_time;
    this.instrument = patch.instrument;
    this.fieldParameter = patch.field_parameter;
    this.standardUsed = patch.standard_used;
    this.verification = patch.verification;
    this.units = patch.units;
  }

  toJson() {
    return {
      id: this.id,
      sampling_event_id: this.samplingEventId,
      calibration_date: this.calibrationDate,
      calibration_time: this.calibrationTime,
      instrument: this.instrument,
      standard_used: this.standardUsed,
      field_parameter: this.fieldParameter,
      verification: this.verification,
      units: this.units,
      pass_fail: this.passFail,
      employee_id: this.employeeId,
      employee_name: this.employeeName,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
    };
  }

  // We send all data per edit or save of a water calibration log since it is editted in the same modal and not outside of the modal.
  toPatch(action) {
    const patch = {
      patch_type: "water_calibration_log",
      action: action,
      id: this.id,
      calibration_date: this.calibrationDate,
      calibration_time: this.calibrationTime,
      instrument: this.instrument,
      field_parameter: this.fieldParameter,
      standard_used: this.standardUsed,
      verification: this.verification || null,
      units: this.units,
      pass_fail: this.passFail,
      employee_id: this.employeeId,
      employee_name: this.employeeName,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
    };
    return patch;
  }
}
